import type {
  FindPodcastListeningTimeQuery,
  FindPodcastListeningTimeQueryVariables,
  UpdatePodcastListeningTimeMutation,
  UpdatePodcastListeningTimeMutationVariables,
  CreatePodcastListeningTimeMutation,
  CreatePodcastListeningTimeMutationVariables,
  PodcastListeningTimeInput,
  PodcastListeningTime,
} from '@edwin-group/cj-graphql/generated/graphql';
import requestHandler from '../requestHandler';
import { initializeApollo } from '../lib/apollo-client';
import {
  QUERY_FIND_LISTENING_TIME,
  MUTATION_CREATE_PODCAST_LISTENING_TIME,
  MUTATION_UPDATE_PODCAST_LISTENING_TIME,
} from '@edwin-group/cj-graphql';
import { getAuthentication } from '@/hooks/useAuthentication';

export const findListeningTime = async (podcastId: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FindPodcastListeningTimeQuery, FindPodcastListeningTimeQueryVariables>({
      query: QUERY_FIND_LISTENING_TIME,
      variables: {
        filters: {
          staff: {
            documentId: { eq: getAuthentication()?.user?.documentId || '' },
          },
          podcast: {
            documentId: { eq: podcastId },
          },
        },
      },
      fetchPolicy: 'no-cache',
    }),
  );

  if (error) {
    console.error('Error listening time', error);
    return { listeningTime: null };
  }

  return {
    listeningTime: data?.podcastListeningTimes?.length
      ? (data?.podcastListeningTimes[0] as PodcastListeningTime)
      : { documentId: null, id: null, listeningTime: 0, duration: 0 },
  };
};

export const createPodcastListeningTime = async (inputData: PodcastListeningTimeInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<CreatePodcastListeningTimeMutation, CreatePodcastListeningTimeMutationVariables>({
      mutation: MUTATION_CREATE_PODCAST_LISTENING_TIME,
      variables: {
        input: inputData,
      },
    }),
  );

  return { data, error };
};
export const updatePodcastListeningTime = async (id: string, inputData: PodcastListeningTimeInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<UpdatePodcastListeningTimeMutation, UpdatePodcastListeningTimeMutationVariables>({
      mutation: MUTATION_UPDATE_PODCAST_LISTENING_TIME,
      variables: {
        id,
        input: inputData,
      },
    }),
  );

  return { data, error };
};
